// This file contains logic around requesting media download URLs.
// It's wrapped with a custom caching/deduping layer (see `./cache.ts`).
// Very similar to `./directURL.ts`.

import {isNotNullOrUndefined} from '@wandb/weave/common/util/types';

import {
  DirectUrlQueryQuery,
  DirectUrlQueryQueryVariables,
} from '../../../../generated/graphql';
import {DIRECT_URL_QUERY} from '../../../../graphql/media';
import {fetchGQL} from '../util';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {BaseFetchParams} from '.';
import {fetchWithCache} from './cacheNew';

const directURLPromiseByFilePathKey: Map<string, Promise<string>> = new Map();
const internalURLPromiseByFilePathKey: Map<string, Promise<string>> = new Map();

export async function fetchDirectURLByFilePath({
  runSignature,
  filePaths,
}: BaseFetchParams) {
  return fetchWithCache({
    runSignature,
    filePaths,
    directAssetUrlPromisesByKey: directURLPromiseByFilePathKey,
    internalAssetUrlPromisesByKey: internalURLPromiseByFilePathKey,
    fetchNew: fetchDirectURLByFilePathUncached,
  });
}

async function fetchDirectURLByFilePathUncached({
  runSignature,
  filePaths,
}: BaseFetchParams): Promise<[Map<string, string>, Map<string, string>]> {
  if (filePaths.length === 0) {
    return [new Map(), new Map()];
  }

  const data = await fetchGQL<
    DirectUrlQueryQueryVariables,
    DirectUrlQueryQuery
  >({
    query: DIRECT_URL_QUERY,
    variables: {
      ...runSignature,
      filenames: filePaths,
    },
  });

  const files =
    data?.project?.run?.files?.edges
      .map(e => e.node)
      .filter(isNotNullOrUndefined) ?? [];

  return [
    new Map(files.map(f => [f.name, f.directUrl])),
    new Map(files.map(f => [f.name, f.url || ''])),
  ];
}
